import React from 'react';
import { locationitem } from './Datatype';

interface props {
  locations: locationitem[];
  openedit: (item: locationitem) => void;
  deletelocation: (item: locationitem) => void;
}

const LocationTable: React.FC<props> = ({ locations, openedit, deletelocation }) => {
  const rows = locations.map((item, i) => (
    <tr key={item._id || i}>
      <td style={{ width: '60px' }}>
        <select
          className="action-select"
          value=""
          onChange={(e) => {
            e.target.value === "edit" && openedit(item);
            e.target.value === "delete" && deletelocation(item);
          }}
        >
          <option value="" disabled>{i + 1}</option>
          <option value="edit">edit</option>
          <option value="delete">delete</option>
        </select>
      </td>
      <td><strong>{item.code}</strong></td>
      <td>{item.pins}</td>
      <td>{item.capacitylimit}</td>
      <td><span className={`status-badge ${item.status}`}>{item.status}</span></td>
    </tr>
  ));

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>zone code</th>
          <th>serviceable pins</th>
          <th>capacity limit</th>
          <th>zone status</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? rows : (
          <tr>
            <td colSpan={5} style={{ textAlign: 'center', padding: '16px' }}>No locations found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default LocationTable;
